export default __webpack_public_path__ + "static/media/personal.4bbf9d62.svg";